export default __webpack_public_path__ + "static/media/IMG-20240729-WA0014.f5c3f2cd.jpg";